/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BereichTriggerRequest } from '../model/bereichTriggerRequest';
// @ts-ignore
import { DisplaysteuerungRolleBerechtigungenRequest } from '../model/displaysteuerungRolleBerechtigungenRequest';
// @ts-ignore
import { RolleIdentifier } from '../model/rolleIdentifier';
// @ts-ignore
import { TriggerIdentifier } from '../model/triggerIdentifier';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class DisplaysteuerungCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostBereichTriggerAusloesen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * TriggerNichtGefunden: (DisplaysteuerungTriggerNichtGefunden) 
     * @endpoint post /api/disp/command/v1/bereich/trigger/ausloesen
     * @param bereichTriggerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBereichTriggerAusloesen(bereichTriggerRequest: BereichTriggerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TriggerIdentifier>;
    public postBereichTriggerAusloesen(bereichTriggerRequest: BereichTriggerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TriggerIdentifier>>;
    public postBereichTriggerAusloesen(bereichTriggerRequest: BereichTriggerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TriggerIdentifier>>;
    public postBereichTriggerAusloesen(bereichTriggerRequest: BereichTriggerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bereichTriggerRequest === null || bereichTriggerRequest === undefined) {
            throw new Error('Required parameter bereichTriggerRequest was null or undefined when calling postBereichTriggerAusloesen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/command/v1/bereich/trigger/ausloesen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TriggerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bereichTriggerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDisplaysteuerungRolleBerechtigungenSetzen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/disp/command/v1/rolle/berechtigungen
     * @param displaysteuerungRolleBerechtigungenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDisplaysteuerungRolleBerechtigungenSetzen(displaysteuerungRolleBerechtigungenRequest: DisplaysteuerungRolleBerechtigungenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolleIdentifier>;
    public postDisplaysteuerungRolleBerechtigungenSetzen(displaysteuerungRolleBerechtigungenRequest: DisplaysteuerungRolleBerechtigungenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolleIdentifier>>;
    public postDisplaysteuerungRolleBerechtigungenSetzen(displaysteuerungRolleBerechtigungenRequest: DisplaysteuerungRolleBerechtigungenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolleIdentifier>>;
    public postDisplaysteuerungRolleBerechtigungenSetzen(displaysteuerungRolleBerechtigungenRequest: DisplaysteuerungRolleBerechtigungenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (displaysteuerungRolleBerechtigungenRequest === null || displaysteuerungRolleBerechtigungenRequest === undefined) {
            throw new Error('Required parameter displaysteuerungRolleBerechtigungenRequest was null or undefined when calling postDisplaysteuerungRolleBerechtigungenSetzen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/disp/command/v1/rolle/berechtigungen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RolleIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: displaysteuerungRolleBerechtigungenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
